const BubbleDisplayOptions = Object.freeze({
  BUBBLES: 'BUBBLES',
  IMAGES: 'IMAGES'
})
export default BubbleDisplayOptions
export type BubbleDisplayOptionsStrings = typeof BubbleDisplayOptions[keyof typeof BubbleDisplayOptions]
// RESERVE BELOW
